import { createWithEqualityFn } from "zustand/traditional";
import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";

interface ILoaderStore {
  sidebarLoading: boolean;
  headerLoading: boolean;
  bannerLoading: boolean;
  contentLoading: boolean;
  overlayLoading: boolean;
  setSidebarLoading: (status: boolean) => void;
  setHeaderLoading: (status: boolean) => void;
  setBannerLoading: (status: boolean) => void;
  setContentLoading: (status: boolean) => void;
  setOverlayLoading: (status: boolean) => void;
}

const store = (set, get) => ({
  sidebarLoading: false,
  headerLoading: false,
  bannerLoading: false,
  contentLoading: false,
  overlayLoading: false,
  setSidebarLoading: (status: boolean) => {
    const { headerLoading, bannerLoading, contentLoading, setOverlayLoading } =
      get();
    if (status) {
      setOverlayLoading(true);
    } else if (!headerLoading && !bannerLoading && !contentLoading && !status) {
      setOverlayLoading(false);
    }
    set({ sidebarLoading: status }, false, "Set Sidebar Loading");
  },
  setHeaderLoading: (status: boolean) => {
    const { sidebarLoading, bannerLoading, contentLoading, setOverlayLoading } =
      get();
    if (status) {
      setOverlayLoading(true);
    } else if (
      !sidebarLoading &&
      !bannerLoading &&
      !contentLoading &&
      !status
    ) {
      setOverlayLoading(false);
    }
    set({ headerLoading: status }, false, "Set Header Loading");
  },
  setBannerLoading: (status: boolean) => {
    const { sidebarLoading, headerLoading, contentLoading, setOverlayLoading } =
      get();
    if (status) {
      setOverlayLoading(true);
    } else if (
      !sidebarLoading &&
      !headerLoading &&
      !contentLoading &&
      !status
    ) {
      setOverlayLoading(false);
    }
    set({ bannerLoading: status }, false, "Set Banner Loading");
  },
  setContentLoading: (status: boolean) => {
    const { sidebarLoading, headerLoading, bannerLoading, setOverlayLoading } =
      get();
    if (status) {
      setOverlayLoading(true);
    } else if (!sidebarLoading && !headerLoading && !bannerLoading && !status) {
      setOverlayLoading(false);
    }
    set({ contentLoading: status }, false, "Set Content Loading");
  },
  setOverlayLoading: (status: boolean) => {
    set({ overlayLoading: status }, false, "Set Overlay Loading");
  },
});

export const useLoaderStore = createWithEqualityFn<ILoaderStore>()(
  devtools(store, { name: "Loader Store" }),
  shallow,
);
